

class CollectionViewMode extends HTMLElement {
    constructor() {
        super();
        this.modes = this.querySelectorAll('.viewmode');
        this.collectionList = document.querySelector('.new-grid');

        // this.VIEWMODE_LOCAL_STORAGE_KEY = 'DrPenCollectionListViewMode';

        Array.from(this.modes).forEach(function(mode, index){
            mode.addEventListener('click', this.switchMode.bind(this));
        }, this);
        
    }

    switchMode(e){
        let modeE = e.target;
        let viewMode = modeE.dataset.view;
        this.setMode(viewMode);
        // if(this.isLocalStorageSupported()) {
        //     localStorage.setItem(this.VIEWMODE_LOCAL_STORAGE_KEY, viewMode);
        // }
    }
    setMode(viewMode) {
        Array.from(this.modes).forEach(function(mode, index){
            let view = mode.dataset.view;
            if(view == viewMode) {
                mode.classList.add('active');
                if(view == 'row') {
                    this.collectionList.classList.add('scroller');
                }else {
                    this.collectionList.classList.remove('scroller');
                }
                
            }else {
                mode.classList.remove('active');
            }
        }, this);
    }
    checkCurrentMode() {
        if(this.isLocalStorageSupported()) {
            this.viewMode = localStorage.getItem(this.VIEWMODE_LOCAL_STORAGE_KEY);
        }
    }
    isLocalStorageSupported() {
        try {
          return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
        } catch (e) {
          return false;
        }
    }
}
customElements.define('collection-viewmode', CollectionViewMode);